import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import SimulateurAmzAds from '@/components/simulateurs/SimulateurAmzAds';

const SESSION_KEY = 'admin_authenticated';

export default function AdminSimulateurAmzAds() {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) !== 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Simulateur Amazon Ads - Admin - Cosmos Wave</title>
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="mb-8">
            <Button variant="ghost" asChild className="mb-4">
              <Link to="/admin/simulateurs">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour aux simulateurs
              </Link>
            </Button>
            <div className="border-b-2 border-primary pb-4">
              <h1 className="text-4xl font-bold text-primary">Simulateur Amazon Ads - Cosmos Wave</h1>
              <p className="text-muted-foreground mt-2">
                Entrez les informations essentielles pour générer votre stratégie publicitaire Amazon Ads personnalisée
              </p>
            </div>
          </div>

          <SimulateurAmzAds />

          <div className="mt-12 text-center text-sm text-muted-foreground">
            <span className="font-bold text-primary">Cosmos Wave</span> Marketing
          </div>
        </div>
      </div>
    </>
  );
}
